<template>
<v-container>
  <toast v-model="toastText"></toast>
  <v-layout row justify-center v-if="loading">
    <progress-dialog>{{ $t('loading') }}</progress-dialog>
  </v-layout>
  <v-layout row justify-center v-else-if="clients.length===0">
    <span class="title grey--text mt-5">{{ $t('client.no_client_available') }}</span>
  </v-layout>
  <v-layout row justify-center v-else>
    <v-flex xs12 sm8 md6>
      <v-card>
        <v-list two-line subheader>
          <v-subheader inset>{{ $t('client.activated_client') }}</v-subheader>
          <template v-for="(item,index) in sortedClients">
            <v-divider inset v-if="index>0" :key="index"></v-divider>
            <v-list-tile avatar :key="item['.key']">
              <v-list-tile-avatar>
                <v-avatar size="40" tile>
                  <img :src="iconifyPlatform(item.platform)">
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ titlePlatform(item.platform) }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  <span class="grey--text mr-2">{{ new Date(item.registeredTime).toLocaleString() }}</span>
                  <span class="indigo--text" v-if="item.displayName">{{ item.displayName }}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action v-show="!loading">
                <v-btn icon v-on:click.stop="removeClient(item)" :disabled="!userId">
                  <v-tooltip left>
                    <v-icon color="primary" slot="activator">close</v-icon>
                    <span>{{ $t('client.remove_client') }}</span>
                  </v-tooltip>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {
  UserAuth
} from 'luffanet-web-components'

export default {
  name: 'Client',
  mixins: [UserAuth],
  data: () => ({
    toastText:null,
    loading: true,
    clients: []
  }),
  computed: {
    sortedClients() {
      return this.clients.sort((a, b) => b.registeredTime - a.registeredTime);
    }
  },
  methods: {
    load() {
      this.$bindAsArray('clients', this.$db.ref('userClient').child(this.userId), null, function() {
        this.loading = false;
      });
    },
    removeClient(client) {
      this.$db.ref('clientRemover').child(this.userId).set(client['.key']);
      this.toastText = this.$t('client.client_removed', {
        client: this.titlePlatform(client.platform)
      });
    },
    iconifyPlatform(platform) {
      switch (platform) {
        case 'actions':
          return require('../assets/assistant.png');
        case 'alexa':
          return require('../assets/alexa.png');
        case 'skype':
          return require('../assets/skype.png');
        case 'telegram':
          return require('../assets/telegram.png');
        case 'messenger':
          return require('../assets/messenger.png');
        case 'viber':
          return require('../assets/viber.png');
        case 'kik':
          return require('../assets/kik.png');
        case 'line':
          return require('../assets/line.png');
      }
    },
    titlePlatform(platform) {
      switch (platform) {
        case 'actions':
          return 'Google Assistant';
        case 'alexa':
          return 'Amazon Alexa';
        case 'skype':
          return 'Microsoft Skype';
        case 'telegram':
          return 'Telegram';
        case 'messenger':
          return 'Facebook Messenger';
        case 'viber':
          return 'Rakuten Viber';
        case 'kik':
          return 'Kik';
        case 'line':
          return 'Line';
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/client.vue